export default "__VITE_ASSET__DhIuwZYb__"